import React from "react";
import "./BackgroundImageSelector.css"
import {BackgroundImages} from "../../assets/BackgroundImage";

type BackgroundImageSelectorProps = {
    className?: string;
    onChange?: (backgound: string) => void;
}

export const BackgroundImageSelector = (props: BackgroundImageSelectorProps) => {

    const class_name = props.className || '';
    const handleChangeBackgroundKey = (background: string) => {
        props.onChange?.(background);
    }

    return (
        <div className={`background-image-selector ${class_name}`}>
            {BackgroundImages.map(
                b => (
                    <div key={b.key}>
                        <img src={b.thumbnail} alt={b.key}
                             onClick={() => handleChangeBackgroundKey(b.key)}/>
                    </div>
                )
            )}
        </div>
    );
}
